import LanguageSwitcher from 'components/LanguageSwitcher/LanguageSwitcher'
import style from './RightButtons.module.css'

const LanguageSwitcherButton = () => {
  return (
    <div className={style.languageButton}>
      <LanguageSwitcher />
    </div>
  )
}

export default LanguageSwitcherButton
